// extracted by mini-css-extract-plugin
export default {"text-area":"CaptionEditModal--text-area--xLzav","textArea":"CaptionEditModal--text-area--xLzav"};